import styled from "styled-components/macro"

export const SchemaMappingWrap = styled.div`
  margin-top: 20px;
`
